import React, { useContext } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import { Card, useTheme } from '@rneui/themed';
import { MaterialIcons } from '@expo/vector-icons';
import { useTranslation } from 'react-i18next';
import ConsumptionContext from '../consumption-context';
import ProgressTable from '../components/blocks/ProgressTable';
import BarChartUnitsPerWeek from '../components/blocks/BarchartUnitsPerWeek';
import BarChartAveragePerDay from '../components/blocks/BarChartAveragePerDay';
import DailyComments from '../components/blocks/DailyComments';
import Goal from '../components/blocks/Goal';
import HelpButton from '../components/buttons/HelpButton';

const OverviewScreen = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { dailyComments, userDoc, total } = useContext(ConsumptionContext);
  return (
    <ScrollView>
      {userDoc?.goalText && (
        <Card>
          <Card.Title>{t('overview.goal')}</Card.Title>
          <Card.Divider />
          <Goal goalText={userDoc?.goalText} />
        </Card>
      )}

      <Card>
        <Card.Title>{`${t('overview.latest')} ${
          Object.keys(total?.daily || []).length
        } ${t('overview.days')}`}</Card.Title>
        <Card.Divider />
        <ProgressTable total={total} />
      </Card>
      <Card>
        <Card.Title>{t('overview.stdUnitsWeek')}</Card.Title>
        <Card.Divider />
        <BarChartUnitsPerWeek
          totalWeekly={total?.weekly}
          limitWeek={userDoc?.stdUnitWeek}
          maxWeeks={10}
        />
      </Card>
      <Card>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Card.Title>{t('overview.stdUnitsWeekDay')}</Card.Title>
          <HelpButton
            helpTitle={t('overview.stdUnitsWeekDayHelpTitle')}
            helpText={t('overview.stdUnitsWeekDayHelpText')}
          />
        </View>
        <Card.Divider />
        <BarChartAveragePerDay
          averageByWeekday={total?.averageByWeekday}
          limitDay={userDoc?.stdUnitDay}
        />
      </Card>
      {dailyComments?.length ? (
        <Card>
          <Card.Title>{t('overview.dailyThoughts')}</Card.Title>
          <Card.Divider />
          <DailyComments dailyComments={dailyComments} total={total} />
        </Card>
      ) : null}
    </ScrollView>
  );
};

export default OverviewScreen;
